var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        fill: "none"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M0 4a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v24a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4z",
          fill: "#ffa89d"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M24.32 24.594H7.452a2.54 2.54 0 0 1-2.514-2.514V11.429a2.54 2.54 0 0 1 2.514-2.514H24.32a2.54 2.54 0 0 1 2.514 2.514V22.08c0 1.372-1.097 2.514-2.514 2.514z",
          fill: "#4868fd"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          d:
            "M12.069 8.413c.046.137.046.319.046.502h.869v-.136-.046c-.091-.274-.137-.731-.046-1.143.091.137 6.628-.32 6.08.274-.274-.137.091.274 0 .594-.137.091-.091-.503-.183-.32.046-.046 0 .183.046.091-.046.046 0 .091-.091.137.046.137.046.32.046.549h.046c0-.046 0-.137-.046-.183.137-.091.091.091.091.137 0-.091.046 0 .046.046V8.87v.046h.731c0-.229 0-.411-.046-.549.137-.914.503-2.743-.96-2.834 0 0-6.766-.823-6.674 1.006-.046.594.137 1.326.046 1.874zm6.949-.549v.091c-.046-.046-.046-.046 0-.091zm7.131 8.319h.091c-.046 0-.777-.091-.457-.091h-1.326c-1.6.091-3.794.046-5.44 0-.777 0-1.234-.046-1.737.046.366 0 .046.046.091.046-.549-.137-3.291-.091-3.246-.091-.091-.046-.32 0-.32.046-.412 0 .137-.046.046-.046h-.183.046c-.229.091-.686 0-.96 0l.137.046c-.137 0-.32 0-.183.046-.686-.091-1.508 0-2.149 0 .183.091-.412-.046-.731-.046.183.046-.64 0-.411.046-.731-.091-1.6-.046-2.377-.046-.594.091-1.691-.091-2.103.137v1.097h5.166c-.091.046.183 0 .091 0h.274c-.183.046.046.183.274.091-.503-.046-.091-.091.046-.046.046-.137 1.6-.046 1.783-.091.32 0-.046.046.046.046-.137.046-1.051.046-.457 0-.091 0-.777-.046-.32.046-.183 0-.412.046-.64.046.091.046.046 0 .229.046-.137-.046.594 0 .366-.046.274.046.411.046.686.046-.274-.046.64-.046.594-.046 0 .046.32.046.046.046h1.371c.274.64-.046 2.103 1.6 2.057 1.417 0 1.371-1.463 1.6-2.103h1.463c.503.046 1.006-.046 1.417 0h.183-.091c.366-.046 1.097 0 1.463-.046.137.046.96-.046.686.046.914-.091 2.286-.046 3.2 0 .274.091.684.007.821-.039l-.001-1.294c-.137.091-.409.007-.683.052z",
          fill: "#02016f"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }